import * as React from 'react'
import { createElement } from 'react'
import { ThemeProvider } from '@bestyled/primitives'
import { createGlobalStyle } from 'styled-components'
import { get, merge } from './util'
import { useColorMode } from './ColorModeProvider'

export const StyledThemeProvider = ({ children, theme }) => {
  const [colorMode] = useColorMode()
  const styledTheme = applyColorMode(theme || {}, colorMode)

  return (
    <ThemeProvider theme={styledTheme}>
      <>{children}</>
      <BodyStyle key="theme-body" />
    </ThemeProvider>
  )
}

const applyColorMode = (theme, mode) => {
  if (!mode) {
    return theme
  }
  const modes = get(theme, 'colors.modes', {})
  return merge.all({}, theme, {
    colors: get(modes, mode, {})
  })
}

const BodyStyle = createGlobalStyle<{ theme: any }>`
body {
  color: ${({ theme }) => theme.colors.primary};
  background: ${({ theme }) => theme.colors.background};
}
`

const noflash = `(function() { try {
  var mode = localStorage.getItem('theme-color-mode');
  if (!mode) return
  document.body.classList.add('theme-' + mode);
} catch (e) {} })();`

export const InitializeColorMode = () =>
  createElement('script', {
    key: 'theme-no-flash',
    dangerouslySetInnerHTML: {
      __html: noflash
    }
  })
